import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateGeoCountryModal from '@modals/CreateGeoCountryModal'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateGeoCountryModal: false,
}

const callbacks = (
  component: keyof typeof componentCallbacks,
  setState: (state: Partial<typeof defaultState>) => void,
) => {
  const componentCallbacks = {
    CreateGeoCountryModal: {
      closeModal: () => setState({ showCreateGeoCountryModal: false }),
      createGeoCountry: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateGeoCountryModal,
  } = state

  const modalContext = useModals({ setState })

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreateGeoCountryModal: () => {
        setState({ showCreateGeoCountryModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <CreateGeoCountryModal
        // @ts-expect-error TS2322
          callbacks={callbacks('CreateGeoCountryModal', setState)}
          showModal={showCreateGeoCountryModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
